import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import api from '@/api/enterapply';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async savedetail(params: any) {
    return api.savedetail(params);
  }

  @Action
  async audit(params: any) {
    return api.audit(params);
  }

  @Action
  async close(params: any) {
    return api.close(params);
  }

  @Action
  async installComplete(params: any) {
    return api.installComplete(params);
  }

  @Action
  async auditResearchReport(params: any) {
    return api.auditResearchReport(params);
  }
}
